import { AuthorityListByChainCd, AuthorityViewModels } from './authority.service.viewmodel';
import { map } from 'rxjs/operators';
import { Params } from '@angular/router';
import { Observable, observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthorityService {
  private authority;

  /**
   * 権限スコープ一覧
   */
  public get scopes(): AuthorityViewModels {
    return this.authority;
  }

  /**
   * チェーンCD別権限スコープ一覧
   */
  private get scopesByChain(): AuthorityListByChainCd[] {
    return this.authority.scopesByChain;
  }

  constructor(
    private http: HttpClient
  ) { }

  public getAuthority(organization: string, id: string) {
    const httpOptions: any = {
      headers: new HttpHeaders({
        'contet-type': 'application/json',
      }),
      params: {
        'organization': organization,
        'userId': id
      }
    };
    this.http.get(environment.apiEndPoint + 'api/home/get-authority', httpOptions).subscribe(x => {
      this.authority = x;
      });
  }

  /**
   * 指定されたチェーンCDに紐づく権限一覧を返す
   * @param chainCd チェーンCD
   * @returns 権限一覧
   */
  public getScopesByChain(chainCd: string): AuthorityListByChainCd {
    const res = this.scopesByChain;
    return res.find(x => x.chainCd === chainCd);
  }
}
